import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const TechCTA = ({ title, titleGradient, description, ctaText = "Let's Talk" }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <section 
      className="py-24 px-6 md:px-12 relative text-center"
      style={{ backgroundColor: '#ffffff' }}
    >
      <div className="max-w-[1240px] mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="bg-[#001534] rounded-2xl p-12 md:p-16"
        >
          <h2 className="text-3xl md:text-5xl font-bold mb-5 text-white leading-tight">
            {title} <span style={{ background: 'linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>{titleGradient}</span>
          </h2>
          <p 
            className="text-base md:text-lg max-w-[640px] mx-auto mb-10 leading-relaxed"
            style={{ color: '#cbd5e1' }}
          >
            {description}
          </p>
          <Link
            to="/contact"
            onClick={() => window.scrollTo(0, 0)}
            className="inline-flex items-center gap-3 py-[18px] px-[44px] text-lg font-bold transition-all duration-300 hover:-translate-y-1 group"
            style={{
              background: "#ffffff",
              color: '#001534',
              boxShadow: isHovered 
                ? '0 8px 36px rgba(0, 198, 255, 0.5)' 
                : '0 4px 24px rgba(0, 198, 255, 0.35)'
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <span>{ctaText}</span>
            <svg 
              className="transition-transform duration-300 group-hover:translate-x-1" 
              width="22" 
              height="22" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M5 12h14" />
              <path d="m12 5 7 7-7 7" />
            </svg>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default TechCTA;
